import { Svatky } from "./Svatky.js";

class Online {
  constructor(config) {
    this.config = config || {};
    this.Otevreno = this.config.otevreno || {};
    this.Svatky = new Svatky(this.config.svatky || {});
  }

  jePracovniDen(datum = new Date()) {
    let denVTydnu = datum.getDay();
    return denVTydnu >= 1 && denVTydnu <= 5;
  }

  vratMinuty(cas) {
    let casti = String(cas || "").split(":");
    let hodiny = parseInt(casti[0], 10);
    let minuty = parseInt(casti[1] || "0", 10);

    if (isNaN(hodiny) || isNaN(minuty)) {
      return null;
    }

    return hodiny * 60 + minuty;
  }

  jeCasMezi(datum, od, doCas) {
    let ted = datum.getHours() * 60 + datum.getMinutes();
    let odMin = this.vratMinuty(od);
    let doMin = this.vratMinuty(doCas);

    if (odMin === null || doMin === null) {
      return false;
    }

    return ted >= odMin && ted < doMin;
  }

  jeOnline(datum = new Date()) {
    if (!this.jePracovniDen(datum)) {
      return false;
    }

    if (this.Svatky.jeSvatek(datum)) {
      return false;
    }

    return this.jeCasMezi(
      datum,
      this.Otevreno.od || "09:00",
      this.Otevreno.do || "17:00",
    );
  }

  // eslint-disable-next-line no-unused-vars
  isOnline(datum = new Date()) {
    return true;
    //return this.jeOnline(datum);
  }
}

export { Online };
